<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-row class="mb-4">
              <b-col lg="9" xl="10" md="12" class="d-flex flex-column mb-4">
                <h2 slot="header" class="mb-0">จัดการสินค้า</h2>
                <div class="text-body-1">
                  แสดงตารางรายละเอียดสินค้าทั้งหมดที่มีอยู่
                </div>
              </b-col>
              <b-col lg="3" xl="2" md="12" class="text-right">
                <base-button type="primary" class="d-flex align-items-center" block @click="openModalItem()">
                  <b-icon icon="plus-circle" class="mr-2"></b-icon> เพิ่มสินค้า
                </base-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="4" md="12" class="mb-2">
                <b-form-datepicker
                  placeholder="วันที่เริ่ม"
                  v-model="dates.start"
                  class="mb-2"
                  locale="th"
                ></b-form-datepicker>
              </b-col>
              <b-col lg="4" md="12" class="mb-2">
                <b-form-datepicker
                  placeholder="วันที่สิ้นสุด"
                  v-model="dates.start"
                  class="mb-2"
                  locale="th"
                ></b-form-datepicker>
              </b-col>
              <b-col lg="2" md="12" class="mb-2">
                <b-form-select
                  v-model="itemSelected"
                  :options="itemList"
                ></b-form-select>
              </b-col>
              <b-col lg="2" md="12" class="mb-2">
                <base-button type="default" class="d-flex align-items-center" block>
                  <b-icon icon="search" class="mr-2"></b-icon> ค้นหา
                </base-button>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col>
                <b-table
                  responsive
                  :fields="fields"
                  :items="items"
                >
                  <template #cell(index)="data">
                    {{ data.index+1 }}
                  </template>
                  <template #cell(image)="data">
                    <b-img
                      :src="data.item.image"
                      fluid
                      width="100px"
                      rounded
                    ></b-img>
                  </template>
                  <template #cell(manage)="data">
                    <b-button
                      variant="outline-border"
                      size="sm"
                      @click="setItemEdit()"
                    >
                      <!-- @click="
                        $router.push({
                          name: 'manageItemId',
                          params: { id: data.item.id },
                        })
                      " -->
                      <b-icon icon="pencil-square"></b-icon>
                    </b-button>
                    <b-button variant="outline-danger" size="sm">
                      <b-icon icon="trash-fill"></b-icon>
                    </b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </card>
        </b-col>
      </b-row>
      <ModalItem :form="form" />
    </b-container>
  </div>
</template>
<script>
import items from "/src/db/item-list.json";
import ModalItem from "@/components/Item/ModalItem.vue"

export default {
  components: {
    ModalItem
  },
  props: {},
  data() {
    return {
      dates: {},
      itemSelected: null,
      itemList: [{ value: null, text: "สินค้าทั้งหมด" }],
      items,
      fields: [
        {
          key: "index",
          label: "ลำดับ",
        },
        {
          key: "name",
          label: "ชื่อรายการ",
        },
        {
          key: "image",
          label: "รูปภาพ",
        },
        {
          key: "type",
          label: "ประเภท",
        },
        {
          key: "dimension",
          label: "ขนาด",
        },
        {
          key: "weight",
          label: "น้ำหนัก",
        },
        {
          key: "no",
          label: "จำนวน",
        },
        {
          key: "manage",
          label: "การจัดการ",
        },
      ],
      form: {
        show: false,
        isLoad: false,
        item: {
          name: null,
          details: null,
          type: null,
          weight: null,
          price: null,
          dimension: {
            width: null,
            lenght: null,
            height: null
          },
          image: {
            file: null,
            preview: null
          }
        }
      }
    };
  },
  created() {},
  methods: {
    openModalItem(){
      this.form.show = true
    },
    setItemEdit() {
      this.openModalItem();
    }
  },
  mounted() {},
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
